import React from "react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import dpclaimstab from '../assets/claims_header_tab.png';
import Typography from '@material-ui/core/Typography';
import ls from 'local-storage';

import InfoIcon from '@material-ui/icons/Info';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import forge from 'node-forge';

const styles = theme => ({

  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  wrappingA:{
      marginTop:"10vh",
  },
});

class ForgotPassword extends React.Component {

  state = {
    value: 0,
    credentials:[],
    offline:false,
    showTerms: false,
    loginResult: {},
    username:"",
    pw1:"",
    pw2:"",
    authsuccess:true,
  };

    authstring="";

    constructor(props){
        super(props);
        this.props=props;
        this._didCreate=true;
        if(props.match.params.auth){
            this.authstring = props.match.params.auth;
        }
    }

    handleTextChange = name => event => {
        let sdatatmp = this.state.staffdata;

        sdatatmp[name] = event.target.value;

        this.setState({staffdata: sdatatmp});
    };

    termsClose = () => {
        this.setState({showTerms: false});
    }


    componentDidMount = (d)=>{
        this.props.socket.emit("validate_authcode",{authcode:this.authstring});
        this.props.socket.on("validate_authcode_return",data=>{
            this.setState({authsuccess:data});
        });
    };
    handleTextChange = event => {
        this.setState({[event.target.name]:event.target.value });
    };

    resetPassword = d=>{
        this.props.socket.emit("forgotpassword",{username:this.state.username});
        ls.set("resetpassword","true");
        this.props.history.push("/");
    }
    sendResetPassword = d=>{
        
        if(this.state.pw1===this.state.pw2 && this.state.pw1!=="" && this.state.pw2!==""){
            var md = forge.md.sha256.create();
            md.update(this.state.pw1);
                
            var encpass = md.digest().toHex();
            var passworddetails = {newpassword:encpass,authcode:this.authstring};
            this.props.socket.emit("forgotpassword_reset",passworddetails);
            ls.set("resetfinished","true");
            this.props.history.push("/");
            
        }else{
            this.snackbarText="Your passwords must match!";
            this.setState({ snackopen: true });
        }
    }

    closeSnack = (event,reason)=>{
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ snackopen: false });
    } 

    render(){
        const { classes } = this.props;
    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={this.state.snackopen}
                autoHideDuration={6000}
                onClose={this.closeSnack}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id"><InfoIcon/> {this.snackbarText}</span>}
                action={[
                    
                    <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={this.closeSnack}
                    >
                    <CloseIcon />
                    </IconButton>,
                ]}
            />
            <img src={dpclaimstab} onClick={()=>{this.props.history.push("/")}} alt="DentalPlus Claims" style={{cursor:"pointer",display:"block",marginTop:"0 !important",marginLeft:"auto",marginRight:"auto"}}></img>
            <div style={{color:"#0072BC"}}>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.wrappingA}
            >
                <Grid item xs={12} sm={6} style={{textAlign:"center"}}>
                    <Typography variant="h5">
                        Forgot Password
                    </Typography>
                    { !this.authstring ?
                    <>
                    <Typography style={{marginTop:"4vh"}}>
                        Please enter your username below to reset your password.
                    </Typography>

                    <TextField
                        id="username"
                        name="username"
                        value={this.state.username}
                        onChange={this.handleTextChange}
                        label="Username"
                        className={classes.textField}
                        //onChange={this.handleChange('name')}
                        margin="normal"
                        style={{marginBottom:"5vh",width:"40vw"}}
                    />
                    <br/>
                    <Button variant="contained" color="secondary" onClick={()=>{this.props.history.push("/")}} style={{marginRight:"1vw"}} className={classes.button}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={this.resetPassword} color="primary" className={classes.button}>
                        Reset password
                    </Button>
                    </>
                    :
                    <>
                        {this.state.authsuccess ?
                            <>
                                <Typography style={{marginTop:"4vh"}}>
                                    Please provide a new password bitch
                                </Typography>

                                <TextField
                                    id="pw1"
                                    name="pw1"
                                    value={this.state.pw1}
                                    onChange={this.handleTextChange}
                                    label="Password"
                                    className={classes.textField}
                                    //onChange={this.handleChange('name')}
                                    type="password"
                                    margin="normal"
                                    style={{marginBottom:"2vh",width:"40vw"}}
                                />
                                <TextField
                                    id="pw2"
                                    name="pw2"
                                    value={this.state.pw2}
                                    onChange={this.handleTextChange}
                                    label="Confirm Password"
                                    className={classes.textField}
                                    //onChange={this.handleChange('name')}
                                    type="password"
                                    margin="normal"
                                    style={{marginBottom:"5vh",width:"40vw"}}
                                />
                                <br/>
                                <Button variant="contained" onClick={this.sendResetPassword} color="primary" className={classes.button}>
                                    Save New Password
                                </Button>
                            </>
                        :
                            <>
                                <Typography style={{marginTop:"4vh",marginBottom:"2vh"}}>
                                    Password reset link is invalid.
                                </Typography>
                                <Button variant="contained" color="secondary" onClick={()=>{this.props.history.push("/")}} style={{marginRight:"1vw"}} className={classes.button}>
                                    Cancel
                                </Button>
                            </>
                        }
                    </>
                    }
                </Grid>
            </Grid>
            </div>
        </>
    );
    }

}

export default withStyles(styles)(ForgotPassword);